import { render, staticRenderFns } from "./Kindergarten.vue?vue&type=template&id=6d356cb0"
import script from "./Kindergarten.vue?vue&type=script&lang=js"
export * from "./Kindergarten.vue?vue&type=script&lang=js"
import style0 from "./Kindergarten.vue?vue&type=style&index=0&id=6d356cb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports